import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion"; 
import api from "../api/api";

// 🔑 Animación de Vibración (Shake)
const shakeAnimation = {
  x: [0, -10, 10, -10, 10, 0], 
  transition: { 
      duration: 0.4, 
      type: "tween",
      ease: "easeInOut"
  },
};

export default function Login() {
  const navigate = useNavigate();

  // 🔒 Bloquear scroll y ajustar altura
  useEffect(() => {
    document.body.style.overflow = "hidden";
    document.body.style.height = "100vh";
    return () => {
      document.body.style.overflow = "auto";
      document.body.style.height = "auto";
    };
  }, []);

  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // ✅ Bloqueo de seguridad
  const [vibrationKey, setVibrationKey] = useState(0); 
  const [isSuccess, setIsSuccess] = useState(false); 

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return; // ✅ Evita doble posteo

    setError("");
    let hasError = false;

    // 🔍 VALIDACIONES FRONTEND
    if (!/\S+@\S+\.\S+/.test(form.email) || form.password.length < 6) {
        setError("Verificá tu email y que la contraseña tenga al menos 6 caracteres.");
        hasError = true;
    }

    if (hasError) {
      setVibrationKey(prev => prev + 1);
      return;
    }

    setLoading(true); // ✅ Iniciamos carga

    try {
      const res = await api.post("/auth/login", form);

      localStorage.setItem("token", res.data.token);
      
      setIsSuccess(true); 

      setTimeout(() => {
        navigate("/");
        window.location.reload();
      }, 500); 

    } catch (err) {
      console.error("Error en login:", err);
      setError(err.response?.data?.message || "Credenciales incorrectas o cuenta no verificada.");
      setVibrationKey(prev => prev + 1);
      setLoading(false); // ✅ Liberamos el botón para reintentar
    }
  };
      
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#FAFAFA",
      }}
    >
      <Link
        to="/"
        style={{
          position: "absolute",
          top: 20,
          left: 20,
          color: "#00796B",
          fontWeight: "600",
          textDecoration: "none",
          fontSize: "16px",
          padding: "6px 10px",
          borderRadius: "6px",
        }}
      >
        ← Volver al inicio
      </Link>

      <motion.div
        key={vibrationKey}
        initial={{ y: -50, opacity: 0 }}
        animate={
          isSuccess
            ? { y: 200, opacity: 0, x: 0 }
            : error
            ? { y: 0, opacity: 1, x: shakeAnimation.x }
            : { y: 0, opacity: 1, x: 0 }
        }
        transition={
          isSuccess
            ? { duration: 0.5, ease: "easeIn" }
            : { y: { duration: 0.5, ease: "easeOut" }, x: shakeAnimation.transition }
        }
        style={{
          width: "360px",
          background: "#fff",
          padding: "32px",
          borderRadius: "16px",
          boxShadow: "0px 4px 18px rgba(0,0,0,0.1)",
          borderTop: "5px solid #00796B",
        }}
      >
          <h2 style={{ textAlign: "center", marginBottom: "10px", color: "#00796B" }}>
            Iniciar Sesión
          </h2>

          <p style={{ textAlign: "center", marginBottom: "25px", color: "#333333" }}>
            Bienvenido nuevamente a <b>OficiAR</b>
          </p>

          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontWeight: "bold", color: "#333333" }}>Email</label>
            <input
              type="email"
              name="email"
              required
              disabled={loading} // ✅ Bloqueo visual
              onChange={handleChange}
              style={{
                padding: "12px",
                marginTop: "6px",
                marginBottom: "18px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                background: loading ? "#f0f0f0" : "white"
              }}
            />

            <label style={{ fontWeight: "bold", color: "#333333" }}>
              Contraseña
            </label>
            <input
              type="password"
              name="password"
              required
              disabled={loading} // ✅ Bloqueo visual
              onChange={handleChange}
              style={{
                padding: "12px",
                marginTop: "6px",
                marginBottom: "22px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                background: loading ? "#f0f0f0" : "white"
              }}
            />

            {error && (
              <p style={{ color: "red", fontWeight: "600", marginBottom: "15px", textAlign: "center" }}>
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={loading} // ✅ Deshabilitar botón
              style={{
                width: "100%",
                padding: "12px",
                background: loading ? "#ccc" : "#00796B",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                cursor: loading ? "not-allowed" : "pointer",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              {loading ? "Cargando..." : "Ingresar"}
            </button>
          </form>

          <p style={{ marginTop: "20px", textAlign: "center", color: "#333" }}>
            ¿No tenés cuenta?{" "}
            <Link to="/register" style={{ color: "#00796B", fontWeight: "bold" }}>
              Crear cuenta
            </Link>
          </p>
        </motion.div>
    </div>
  );
}